<template>
<div>
    
    <section class="page-section" style="background-color:#151117; padding-top:4em">
        <div class="container">
            <div class="row align-items-center justify-content-center text-center">
                <div class="col-lg-10">
                    <img src="/img/no-stopping-merged.png" width="90%" />
                </div>
            </div>
        </div>
    </section>
    
    
    <!-- About-->
    <section class="page-section" id="about" style="background-color:#151117">
        <div class="container-sm">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <h3 class="h4 bold color-red">About</h3>
                    <h4 class="text-white mb-4">
                        At Loonatic Productions it's our goal to capture the sounds and visuals for your next project and bring them to life.             
                    </h4>
                </div>
            </div>
            <div class="row text-white">
                <div class="col-6">
                    <div class="mt-5">
                        <h3 class="h4 mb-2 bold color-red">Sound and Music Composition</h3>
                        <p class="text-white mb-0">Expert music arrangements and instrumental execution.</p>
                    </div>
                </div>
                <div class="col-6">
                    <div class="mt-5">
                        <h3 class="h4 mb-2 bold color-red">Sound Mixing</h3>
                        <p class="text-white mb-0">Realize all the layers to your composition.</p>
                    </div>
                </div>
                <div class="col-6">
                    <div class="mt-5">
                        <h3 class="h4 mb-2 bold color-red">Mastering</h3>
                        <p class="text-white mb-0">High quality productions mastered for all devices.</p>
                    </div>
                </div>
                <div class="col-6">
                    <div class="mt-5">
                        <h3 class="h4 mb-2 bold color-red">Visual Production</h3>
                        <p class="text-white mb-0">Bring your sounds ideas to the eyes.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Numbers -->
    <section class="page-section color-red" style="background-color:#151117" id="numbers">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="bold mt-0 ml-1">Milestones</h2>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-sm-12">
                    <div class="mt-5">
                        <h1><b>7</b></h1>
                        <h5><b>Albums</b></h5>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-12">
                    <div class="mt-5">
                        <h1><b>4</b></h1>
                        <h5><b>Singles</b></h5>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-12">
                    <div class="mt-5">
                        <h1><b>22</b></h1>
                        <h5><b>Music Videos</b></h5>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Listen-->
    <section class="page-section" id="listen">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="bold mt-0 ml-1">Listen</h2>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-sm-12" v-for="album in albums" v-bind:key="album.id">
                    <div class="mt-5">
                        <a class="mb-3" v-bind:href="album.link">
                            <img :data-src="album.img" :data-srcset="album.img" width="300px" async class="rounded shadow play-youtube-video lazy" />
                        </a>
                        <div class="ml-2 mt-2">
                            <h4 class="bold mb-0">{{ album.title }}</h4>
                            <div class="color-red bold mt-0">{{ album.artist }}</div>
                            <div class="color-red mt-0" style="font-size: 11px">{{ album.subtitle }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!-- Music Videos -->
    <section class="page-section pt-3" id="videos">
        <div class="container">
            <h2 class="bold mt-0">Watch</h2>
            <div class="row">
                <div class="col-lg-4 col-sm-12"  v-for="video in videos" v-bind:key="video.id">
                    <div class="mt-5">
                        <a target="_blank" v-bind:href="'https://www.youtube.com/watch?v='+ video.id">
                            <img :data-src="getUrl(video)" :data-srcset="getUrl(video)" async class="rounded w-90 shadow play-youtube-video lazy" />
                        </a>
                        <div class="ml-2 mt-2">
                            <h4 class="bold mb-0">{{ video.title }}</h4>
                            <div class="color-red bold mt-0">{{ video.artist }}</div>
                        </div>
                    </div>
                </div>                
            </div>
        </div>
    </section>
    
    <!-- Loon -->
    <section class="page-section p-0">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <img src="/img/loon-profile.png" width="100%" />
                </div>                
            </div>
        </div>
    </section>
</div>
    
</template>

<script>
export default {
    name: 'Home',
    components: {
    },
    data: function(){
        return{
            albums:[
                {
                    link:"/#/era-of-women",
                    artist:"The Raj!",
                    title:"Era of Women",
                    subtitle:"Album",
                    img:"/img/era_of_women.webp"
                },
                {
                    link:"https://soundcloud.com/itstheraj/reimagination",
                    artist:"The Raj!",
                    title:"Reimagination",
                    subtitle:"Album",
                    img:"/img/reimagination.webp"
                },
                {
                    link:"https://distrokid.com/hyperfollow/esberandtheraj/the-number-you-have-dialed",
                    artist:"Esber and The Raj!",
                    title:"The Number You Have Dialed",
                    subtitle:"Album",
                    img:"/img/portfolio/number-you-have-dialed-cover.webp"
                },
                {
                    link:"/#/love-with-your-phone", //https://open.spotify.com/track/6kWFtsBIdT5GXc6uXge2yS?si=978d75d8d06242f4
                    artist:"Jono and The Raj!",
                    title:"Love with Your Phone",
                    subtitle:"Album",
                    img:"/img/love-with-your-phone.webp"
                },
                {
                    link:"https://soundcloud.com/itstheraj/sets/ima-do-me",
                    artist:"The Raj!",
                    title:"I'ma Do Me",
                    subtitle:"Album",
                    img:"/img/portfolio/ima-do-me.png"
                },
                {
                    link:"https://open.spotify.com/album/5rwcVlundf8QRkX1o185sV",
                    artist:"The Raj!",
                    title:"Purple Tears",
                    subtitle:"Album",
                    img:"/img/portfolio/purple-tears.png"
                },
                {
                    link:"/#/jesse-if-i-had-the-words",
                    artist:"Jesse",
                    title:"If I Had the Words",
                    subtitle:"Album",
                    img:"/img/article2.jpeg"
                },
                {
                    link:"/#/john-swardson-the-storm",
                    artist:"John Swardson",
                    title:"The Storm",
                    subtitle:"Single",
                    img:"https://f4.bcbits.com/img/a3199116593_16.jpg"
                },
                {
                    link:"https://open.spotify.com/track/6lpGeMMKrPfZaeg2dhvxzL?si=c475c2c7843240e9",
                    artist:"Jesse",
                    title:"In the Morning",
                    subtitle:"Single",
                    img:"/img/ITM.png"
                },
                {
                    link:"https://open.spotify.com/track/2Lg970uEhOyOSCQKbTwnvM?si=9e087c8a83e74ede",
                    artist:"Jesse",
                    title:"Dear Jesse",
                    subtitle:"Single",
                    img:"/img/dear_jesse.png"
                },
                {
                    link:"https://open.spotify.com/track/4GJeoUGwztaaXjceGFKeDO?si=10218791342644a2",
                    artist:"Jono and The Raj!",
                    title:"Cream Puffs",
                    subtitle:"Single",
                    img:"/img/cream_puffs.png"
                }
            ],
            slides:[
                {
                    url:"https://linktr.ee/theraj",
                    img:"/img/love-with-your-phone-album.png",
                    title:"Love with Your Phone",
                    artist:"Jono and the Raj",
                    href:""
                },
                {
                    url:"/#/jesse-if-i-had-the-words",
                    img:"/img/article2.jpeg",
                    title:"If I Had the Words",
                    artist:"Jesse",
                    href:"/#/jesse-if-i-had-the-words"
                },
                {
                    url:"/#/john-swardson-the-storm",
                    img:"https://f4.bcbits.com/img/a3199116593_16.jpg",
                    title:"The Storm",
                    artist:"John Swardson",
                    href:"/#/john-swardson-the-storm"
                },
                {
                    url:"https://open.spotify.com/album/5rwcVlundf8QRkX1o185sV",
                    img:"/img/portfolio/purple-tears.png",
                    title:"Purple Tears",
                    artist:"The Raj!",
                    href:"https://open.spotify.com/album/5rwcVlundf8QRkX1o185sV"
                },
                {
                    url:"https://soundcloud.com/itstheraj/sets/ima-do-me",
                    img:"/img/portfolio/ima-do-me.png",
                    title:"I'ma Do Me",
                    artist:"The Raj!",
                    href:"https://soundcloud.com/itstheraj/sets/ima-do-me"
                },
                {
                    url:"/#/valora-music",
                    img:"/imgs/HW8ShT8_kOU/0.jpg",
                    title:"Valora",
                    artist:"Musical Scores for Crypto",
                    href:"/#/valora-music"
                },
            ],
            videos: [
                {
                    id: 'Sy7VqNvyaII',
                    title:"Cream Puffs",
                    artist:"Jono and the Raj!"
                },
                {
                    id: 'UVdI_V4GDT4',
                    title:"Minnesota Made",
                    artist:"The Raj!"
                },
                {
                    id: 'XA4xAtfbhUQ',
                    title:"Landslide",
                    artist:"The Raj!"
                },
                {
                    id:'tJiJq7vG-Ms',
                    title:"The Leaves (Live at Raj's)",
                    artist:"John Swardson"
                },
                {
                    id:'_ARozMNkhoY',
                    title:"That Western Skyline (Live at Raj's)",
                    artist:"Rudy Nelson"
                },
                {
                    id:'je5ZaK9hh0c',
                    title:"The Storm",
                    artist:"John Swardson"
                },
                {
                    id:'uQfFvDK-KD4',
                    title:"Trask 3",
                    artist:"The Raj!"
                },
                {
                    id:'rHBGznt0iOw',
                    title:"Have You Eva Seen",
                    artist:"Emil Carson"
                },
                {  
                    id:'NfYBXvfkI-w',
                    title:"Bro Code",
                    artist:"Emil Carson"
                },
                {
                    id:'ZnYh12_W3YQ',
                    title:"Rubik's Cube",
                    artist:"Emil Carson"
                },
                {
                    id:'hsae2KkDcVs',
                    title:"'Rona in Minnesota",
                    artist:"The Raj!"
                },
                {
                    id:'Sq_j2iZis6w',
                    title:"MPLS RIOT",
                    artist:"The Raj!"
                },
                {
                    id:'2-9SqiMW4Ys',
                    title:"Booty Rockin' Everywhere",
                    artist:"The Raj!"
                },
                {
                    id:'P8yeNbUEaEg',
                    title:"Summer Camp",
                    artist:"Emil Carson"
                },
                {
                    id:'ho3gTgtSA1Q',
                    title:"Spring Fling",
                    artist:"Emil Carson"
                },
                {
                    id:'wWSsTaaHCOI',
                    title:"What Makes You Masculine",
                    artist:"Emil Carson"
                },
                {
                    id:'_vSwOPyJzCw',
                    title:"Groupon (feat. The Raj!)",
                    artist:"Emil Carson"
                },
                {
                    id:'qFPC8ZQhWzQ',
                    title:"Happy Grind",
                    artist:"The Raj!"
                },
                {
                    id:'ieGvZShRtmA',
                    title:"Giants",
                    artist:"The Raj!"
                },
                {
                    id:'tMAKUmZZ_RM',
                    title:"Midi Me",
                    artist:"The Raj!"
                },
                {
                    id:'q75JXEeOj8Q',
                    title:"Woke Up and Started Dreamin",
                    artist:"Emil Carson"
                },
                {
                    id:'l-xDe53vGXw',
                    title:"Beat 576",
                    artist:"The Raj!"
                }
            ]
        }
    },
    methods:{
        getUrl(video){
            var url = '/imgs/'+video.id+'/0.jpg'
            return url
        }
    }
}

</script>
